import { Suspense, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import {
    CategoryPage,
    DashboardPage,
    ForgotPasswordPage,
    LoginPage,
    MySchoolPage,
    ProfilePage,
    RegionPage,
    SchoolPage,
    ServiceGroupPage,
    SetPasswordPage,
    TokenLoginPage,
    UserPage,
    CoordinatorRequestPage,
    PartnershipSchoolPage,
    TypologyPage,
    InternshipSchedulePage,
    InternshipScheduleSeatPage,
    GesturePage,
    SkillPage,
    SkillCriteriaPage,
    SchoolBatchPage,
    InternshipScheduleSkillPage,
    InternshipScheduleStudentPage,
    StudentPage,
    TimesheetTypePage,
    TimesheetPage,
    InternshipTimesheetPage,
    MessagesPage,
    FindInternshipCompanyPage,
    FindInternshipSchoolPage,
    InternshipScheduleStudentSkillPage,
    MyInternshipPage,
    TrainingPage,
    CompanyDocumentPage,
    InternshipPage,
} from "../pages";
import { useAuthAction } from "../hooks";
import { cPath } from "../config";
import { AppLoader } from "../components";
import {
    CompanyPage,
    MyCompanyPage,
    PartnershipCompanyPage,
} from "../pages/admin/Company";
import { useAuthData } from "../contexts";

const AdminLayout = lazy(() => import("../layout/AdminLayout"));
// const HomeLayout = lazy(() => import("../layout/HomeLayout"));
const LoginLayout = lazy(() => import("../layout/LoginLayout"));

const Logout = () => {
    const { logoutAction } = useAuthAction();
    logoutAction();
    return <></>;
};

const AuthenticatedRoutes = (
    <>
        <Route
            path="*"
            element={<Navigate to={cPath("ADMIN.DASHBOARD_PAGE")} replace />}
        />
        <Route
            path={cPath("ADMIN")}
            element={
                <Suspense fallback={<AppLoader />}>
                    <AdminLayout />
                </Suspense>
            }
        >
            <Route
                path={cPath("ADMIN.DASHBOARD_PAGE", {}, true)}
                element={<DashboardPage />}
            />
            <Route
                path={cPath("ADMIN.PROFILE_PAGE", {}, true)}
                element={<ProfilePage />}
            />
            <Route
                path={cPath("ADMIN.USER_PAGE", {}, true)}
                element={<UserPage />}
            />
            <Route
                path={cPath("ADMIN.COORDINATOR_REQUEST_PAGE", {}, true)}
                element={<CoordinatorRequestPage />}
            />
            <Route
                path={cPath("ADMIN.MY_COMPANY_PAGE", {}, true)}
                element={<MyCompanyPage />}
            />
            <Route
                path={cPath("ADMIN.PARTNERSHIP_COMPANY_PAGE", {}, true)}
                element={<PartnershipCompanyPage />}
            />
            <Route
                path={cPath("ADMIN.REQUEST_PARTNERSHIP_COMPANY_PAGE", {}, true)}
                element={<PartnershipCompanyPage />}
            />
            <Route
                path={cPath(
                    "ADMIN.CREATE_PARTNERSHIP_COMPANY_PAGE_REQUEST",
                    {},
                    true
                )}
                element={<PartnershipCompanyPage />}
            />
            <Route
                path={cPath("ADMIN.COMPANY_PAGE", {}, true)}
                element={<CompanyPage />}
            />
            <Route
                path={cPath("ADMIN.MY_SCHOOL_PAGE", {}, true)}
                element={<MySchoolPage />}
            />
            <Route
                path={cPath("ADMIN.PARTNERSHIP_SCHOOL_PAGE", {}, true)}
                element={<PartnershipSchoolPage />}
            />
            <Route
                path={cPath("ADMIN.REQUEST_PARTNERSHIP_SCHOOL_PAGE", {}, true)}
                element={<PartnershipSchoolPage />}
            />
            <Route
                path={cPath("ADMIN.SCHOOL_PAGE", {}, true)}
                element={<SchoolPage />}
            />
            <Route
                path={cPath("ADMIN.CATEGORY_PAGE", {}, true)}
                element={<CategoryPage />}
            />
            <Route
                path={cPath("ADMIN.SERVICEGROUP_PAGE", {}, true)}
                element={<ServiceGroupPage />}
            />
            <Route
                path={cPath("ADMIN.COMPANYDOCUMENT_PAGE", {}, true)}
                element={<CompanyDocumentPage />}
            />
            <Route
                path={cPath("ADMIN.TYPOLOGY_PAGE", {}, true)}
                element={<TypologyPage />}
            />
            <Route
                path={cPath("ADMIN.TRAINING_PAGE", {}, true)}
                element={<TrainingPage />}
            />
            <Route
                path={cPath("ADMIN.INTERNSHIP_PAGE", {}, true)}
                element={<InternshipPage />}
            />
            <Route
                path={cPath("ADMIN.INTERNSHIP_SCHEDULE_PAGE", {}, true)}
                element={<InternshipSchedulePage />}
            />
            <Route
                path={cPath("ADMIN.INTERNSHIP_SCHEDULE_SEAT_PAGE", {}, true)}
                element={<InternshipScheduleSeatPage />}
            />
            <Route
                path={cPath("ADMIN.INTERNSHIP_SCHEDULE_SKILL_PAGE", {}, true)}
                element={<InternshipScheduleSkillPage />}
            />
            <Route
                path={cPath("ADMIN.MY_INTERNSHIP_PAGE", {}, true)}
                element={<MyInternshipPage />}
            />
            <Route
                path={cPath("ADMIN.FIND_INTERNSHIP_COMPANY_PAGE", {}, true)}
                element={<FindInternshipCompanyPage />}
            />
            <Route
                path={cPath("ADMIN.FIND_INTERNSHIP_SCHOOL_PAGE", {}, true)}
                element={<FindInternshipSchoolPage />}
            />
            <Route
                path={cPath("ADMIN.STUDENT_PAGE", {}, true)}
                element={<StudentPage />}
            />
            <Route
                path={cPath("ADMIN.INTERNSHIP_SCHEDULE_STUDENT_PAGE", {}, true)}
                element={<InternshipScheduleStudentPage />}
            />
            <Route
                path={cPath("ADMIN.STUDENTS_PAGE", {}, true)}
                element={<InternshipScheduleStudentPage />}
            />
            <Route
                path={cPath(
                    "ADMIN.INTERNSHIP_SCHEDULE_STUDENT_SKILL_PAGE",
                    {},
                    true
                )}
                element={<InternshipScheduleStudentSkillPage />}
            />
            <Route
                path={cPath("ADMIN.STUDENTS_SKILL_PAGE", {}, true)}
                element={<InternshipScheduleStudentSkillPage />}
            />
            <Route
                path={cPath("ADMIN.STUDENT_SKILL_PAGE", {}, true)}
                element={<InternshipScheduleStudentSkillPage />}
            />
            <Route
                path={cPath("ADMIN.REGION_PAGE", {}, true)}
                element={<RegionPage />}
            />
            <Route
                path={cPath("ADMIN.SKILL_PAGE", {}, true)}
                element={<SkillPage />}
            />
            <Route
                path={cPath("ADMIN.SKILL_CRITERIA_PAGE", {}, true)}
                element={<SkillCriteriaPage />}
            />
            <Route
                path={cPath("ADMIN.GESTURE_PAGE", {}, true)}
                element={<GesturePage />}
            />
            <Route
                path={cPath("ADMIN.SCHOOL_BATCH_PAGE", {}, true)}
                element={<SchoolBatchPage />}
            />
            <Route
                path={cPath("ADMIN.TIMESHEET_TYPE_PAGE", {}, true)}
                element={<TimesheetTypePage />}
            />
            <Route
                path={cPath("ADMIN.TIMESHEET_PAGE", {}, true)}
                element={<TimesheetPage />}
            />
            <Route
                path={cPath("ADMIN.INTERNSHIP_TIMESHEET_PAGE", {}, true)}
                element={<InternshipTimesheetPage />}
            />
            {/* <Route
                path={cPath("ADMIN.MESSAGE_PAGE", {}, true)}
                element={<MessagePage />}
            /> */}
            <Route
                path={cPath("ADMIN.MESSAGES_PAGE", {}, true)}
                element={<MessagesPage />}
            />
            <Route
                path={cPath("ADMIN.LOGOUT", {}, true)}
                element={<Logout />}
            />
        </Route>
    </>
);

const NonAuthenticatedRoutes = (
    <>
        <Route path="*" element={<Navigate to={cPath("PUBLIC")} replace />} />
        <Route
            path={cPath("PUBLIC")}
            element={
                <Suspense fallback={<AppLoader />}>
                    <LoginLayout />
                </Suspense>
            }
        >
            <Route
                path={cPath(
                    "PUBLIC.SECURITY.TOKEN_LOGIN_PAGE",
                    { token: ":token" },
                    true
                )}
                element={<TokenLoginPage />}
            />
            <Route
                path={cPath("PUBLIC.SECURITY.LOGIN_PAGE", {}, true)}
                element={<LoginPage />}
            />
            <Route
                path={cPath("PUBLIC.SECURITY.FORGOT_PASSWORD_PAGE", {}, true)}
                element={<ForgotPasswordPage />}
            />
            <Route
                path={cPath("PUBLIC.SECURITY.SET_PASSWORD_PAGE", {}, true)}
                element={<SetPasswordPage />}
            />
        </Route>
    </>
);

const RootRoutes = () => {
    const { isAuthenticated } = useAuthData();
    return (
        <Routes>
            {isAuthenticated ? AuthenticatedRoutes : NonAuthenticatedRoutes}
        </Routes>
    );
};

export default RootRoutes;
